import gql from "graphql-tag";

export const LEDGER_FRAGMENT = gql`
  fragment LegderInfo on Legder {
    availableAmount
    bicOrSwift
    friendlyName
    iban
    id
    linkcyId
    reservedAmount
    status
    totalAmount
    transactionDailyLimitUsed
    transactionMonthlyLimitUsed
    ddMonthlyLimit
    ddTransactionLimit
    transactionLimit
    transactionDailyLimit
    transactionMonthlyLimit
  }
`;

export const ACCOUNT_BANKING_FRAGMENT = gql`
  fragment AccountBankingInfo on Account {
    accountCreationHardvalue
    accountCreationName
    accountName
    accountNumber
    balance
    balanceInReview
    bankCode
    bic
    clientId
    closedAt
    closedBy
    currency
    dailyLimit
    dailyLimitUsed
    ddMonthlyLimit
    ddMonthlyLimitUsed
    ddTransactionLimit
    disposableAmount
    disposableAmountUsed
    iban
    id
    isAccountArrested
    isBolCompanyFunds
    isFeeAccount
    lockedAmount
    monthlyLimit
    monthlyLimitUsed
    paynovateId
    reservedBalance
    sortCode
    statusComment
    statusId
    transactionLimit
    typeId
  }
`;
